import { inferRspackPublicPathFromLoadedPacks } from './packAssetRoot';

const rspackPublicPath = inferRspackPublicPathFromLoadedPacks();

if (rspackPublicPath) {
  // Rspack intentionally implements Webpack's public-path runtime variable for compatibility.
  // eslint-disable-next-line camelcase, no-undef
  __webpack_public_path__ = rspackPublicPath;
}

export default rspackPublicPath;
